(() => {
  const SAVE_SELECTOR = 'm-cart-addons .m-cart-addon--save[data-action="coupon"]';
  const DISCOUNT_STORAGE_KEY = 'minimog-discount-code';
  let applying = false;

  const getUpdateUrl = () => {
    if (window.MinimogSettings?.routes?.cart_update_url) return window.MinimogSettings.routes.cart_update_url;
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart/update.js`;
  };

  const ensureMessage = (addon) => {
    const content = addon?.querySelector('#m-addons-coupon .m-cart-addon__content');
    if (!content) return null;
    let message = content.querySelector('.yy-cart-discount-message');
    if (!message) {
      message = document.createElement('p');
      message.className = 'yy-cart-discount-message';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      message.style.margin = '8px 0 0';
      message.style.fontSize = '12px';
      message.style.lineHeight = '1.4';
      content.appendChild(message);
    }
    return message;
  };

  const setMessage = (addon, text, isError = false) => {
    const message = ensureMessage(addon);
    if (!message) return;
    message.textContent = text;
    message.style.color = isError ? '#9a3f31' : '#294436';
  };

  const codeIsApplicable = (cart, code) => {
    if (!code) return true;

    const normalized = code.toLowerCase();
    const discountCodes = Array.isArray(cart?.discount_codes) ? cart.discount_codes : [];
    const matchedCode = discountCodes.find((entry) => String(entry?.code || '').toLowerCase() === normalized);

    if (matchedCode) return matchedCode.applicable !== false;

    const cartApplications = Array.isArray(cart?.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];

    return Number(cart?.total_discount || 0) > 0 || cartApplications.length > 0;
  };

  const refreshCart = (openDrawer) => {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { open: openDrawer }
    }));
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.(SAVE_SELECTOR);
    if (!button) return;

    /* Stop Minimog's legacy handler, which only writes the code to localStorage. */
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (applying) return;

    const addon = button.closest('m-cart-addons');
    const input = addon?.querySelector('[name="discount"]');
    if (!addon || !input) return;

    const code = input.value.trim();
    const originalLabel = button.textContent;
    const isDrawer = Boolean(addon.closest('m-cart-drawer'));

    document.dispatchEvent(new CustomEvent('yy:cart-discount', {
      detail: { status: 'attempt', source: isDrawer ? 'drawer' : 'cart_page', hasCode: Boolean(code) }
    }));

    applying = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = code ? 'Applying…' : 'Removing…';
    setMessage(addon, '');

    try {
      const response = await fetch(getUpdateUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: code })
      });

      if (!response.ok) throw new Error(`Discount request failed (${response.status})`);

      const cart = await response.json();

      if (code && !codeIsApplicable(cart, code)) {
        localStorage.removeItem(DISCOUNT_STORAGE_KEY);
        setMessage(addon, 'This discount code is not valid for your cart.', true);
        document.dispatchEvent(new CustomEvent('yy:cart-discount', {
          detail: { status: 'invalid', source: isDrawer ? 'drawer' : 'cart_page', hasCode: true }
        }));
        return;
      }

      if (code) localStorage.setItem(DISCOUNT_STORAGE_KEY, code);
      else localStorage.removeItem(DISCOUNT_STORAGE_KEY);

      setMessage(addon, code ? 'Discount applied.' : 'Discount removed.');
      document.dispatchEvent(new CustomEvent('yy:cart-discount', {
        detail: { status: code ? 'applied' : 'removed', source: isDrawer ? 'drawer' : 'cart_page', hasCode: Boolean(code) }
      }));
      refreshCart(isDrawer);
    } catch (error) {
      console.error('YETI YOGI discount application error:', error);
      setMessage(addon, 'Could not apply the discount. Please try again.', true);
      document.dispatchEvent(new CustomEvent('yy:cart-discount', {
        detail: { status: 'error', source: isDrawer ? 'drawer' : 'cart_page', hasCode: Boolean(code) }
      }));
    } finally {
      applying = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    }
  }, true);
})();
